<!--TODO FIX classes buggish behaviour-->
<style>
  .mat-form-field-hide-placeholder .mat-select-placeholder {
    color: grey !important;
    -webkit-text-fill-color: grey !important;
  }
</style>
<mat-form-field class="fill" [ngClass]="classes">
  <mat-label *ngIf="label"> {{label}}</mat-label>
  <mat-select (openedChange)="openedChange($event)"
              (selectionChange)="emitSelected($event)"
              [formControl]="selectFormControl"
              placeholder="(+{{selectedValues.length}} selected)"
              panelClass="select-search-many"
              multiple>

    <mat-select-trigger *ngIf="selectedValues?.length > 0">
      <span class="additional-selection">
        (+{{selectedValues.length}} selected)
      </span>
    </mat-select-trigger>
    <div class="select-container">
      <div class="row search">
        <mat-checkbox
            (change)="selectAll()"
            [(ngModel)]="select_all"
            [matTooltip]="select_all? 'Clear all (applies to current filter)': 'Select all (applies to current filter)'"
            style="margin-right:10px;margin-left:16px;">
        </mat-checkbox>
        <mat-form-field>
          <input #search autocomplete="off" matInput
                 (keydown.space)="$event.stopPropagation()" [formControl]="searchTextboxControl">
        </mat-form-field>

        <div>
          <i class="fa fa-times fa-2x" matTooltip="Clear all selected" matSuffix mat-icon-button
             aria-label="Clear"
             (click)="clearAll($event)">
          </i>
        </div>
      </div>
      <mat-optgroup *ngIf="filteredOptions && filteredOptions.length == 0">
        <div>No results found!</div>
      </mat-optgroup>
      <virtual-scroller #scroll
                        *ngIf="filteredOptions" [items]="filteredOptions" class="virtual-scroller"
                        style="width: 100%;  height: 200px;">
        <!-- this div is so that the checkbox is displayed correctly in the virtual scroller-->
        <div style="display:block; width: 100%; height: 30px;">
          <mat-option [title]="description_map[option.id]" (onSelectionChange)="selectionChange($event)"
                      *ngFor="let option of scroll.viewPortItems"
                      [value]="option" style="width: 100%; ">
            {{description_map[option.id]}}
            <span *ngIf="option.attributes?.account_name">: {{option.attributes.account_name.trim()}}</span>
          </mat-option>
        </div>
      </virtual-scroller>
    </div>
  </mat-select>
</mat-form-field>
<div class="select-many-search-selection" *ngIf="selectedValues?.length > 0">
  <i class="fa fa-ellipsis-h" [matMenuTriggerFor]="menu"></i>
  <mat-menu #menu="matMenu" class="current-selection-menu">
    <div class="current-selection">
      <label style="font-weight:bold;">Currently selected items:</label>
      <ul *ngFor="let item of selectedValues">
        <li>
          <span>{{stringFunction(item)}}</span>
          <span *ngIf="item?.attributes?.account_name">{{': ' + item.attributes.account_name.trim()}}</span>
        </li>
        <!--        <li [innerHTML]="stringFunction(item)"></li>-->
      </ul>
    </div>
  </mat-menu>
</div>


<!--<div *ngIf="selectFormControl.value">{{ 'You have choosen ' + selectFormControl.value[] }}</div>-->

<!-- Copyright 2018 Google Inc. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->